export default __webpack_public_path__ + "static/media/mobilebanner.7b5577f6.png";